import { get, post, put, throwIfError } from 'utils/api';

export const getOptions = async (url, options = {}) => {
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const fetchFormData = async ({ url, options = {} }) => get(url, options);

export const saveFormData = async (action, url, values, options) => {
  let response;
  if (action === 'post') {
    response = await post(url, values, options);
  } else {
    response = await put(url, values, options);
  }

  if (response.error) {
    return response.error;
  }

  return response;
};

export const saveShortFormData = async ({
  organizationId,
  propertyId,
  applicantId,
  payload,
  options,
}) => {
  const url = `/${organizationId}/${propertyId}/shortForms/${applicantId}`;
  const response = await post(url, payload, options);

  if (response.error) {
    return response.error;
  }

  return response;
};

export const getPrimaryFormData = async ({
  organizationId,
  propertyId,
  applicantId,
  options,
}) => {
  const url = `/${organizationId}/${propertyId}/primaryForms/${applicantId}`;

  const response = await get(url, options);

  return throwIfError(response);
};

export const savePrimaryFormData = async ({
  organizationId,
  propertyId,
  applicantId,
  payload,
  options,
}) => {
  const url = `/${organizationId}/${propertyId}/primaryForms/${applicantId}`;

  const response = await post(url, payload, options);

  return throwIfError(response);
};

export const getSecondaryFormData = async ({
  organizationId,
  propertyId,
  applicantId,
  options,
}) => {
  const url = `/${organizationId}/${propertyId}/secondaryForms/${applicantId}`;

  const response = await get(url, options);

  return throwIfError(response);
};

export const saveSecondaryFormData = async ({
  organizationId,
  propertyId,
  applicantId,
  payload,
  options,
}) => {
  const url = `/${organizationId}/${propertyId}/secondaryForms/${applicantId}`;

  const response = await post(url, payload, options);

  return throwIfError(response);
};
